import styled, { keyframes } from 'styled-components'
import { Button as ButtonComponent, Sidebar as SidebarComponent } from 'ui'
import HeaderComponent from './header'
import SectionComponent from './section'

const buttonIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Button = styled(ButtonComponent)`
    animation: ${buttonIn} 0.15s ease-out;
    position: fixed;
    right: 20px;
    top: 14px;
`

export const Header = styled(HeaderComponent)`
    margin-bottom: 25px;
`

export const Section = styled(SectionComponent)`
    margin-bottom: 25px;
`

export const Sidebar = styled(SidebarComponent)`
    z-index: 999;
`
